import React from "react";
import "../styles/home.css";
import Navbar from "../components/BlogNavbar";
import Accelerator from "../components/AcceleratorSection";

const Home = () => {
  return (
    <div className="home">
      <Navbar />
      <Accelerator />
    </div>
  );
};

export default Home;
